import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { HelperService, HTTPService } from 'app/services';

@Component({
  selector: 'app-tireconnect-suppliers',
  templateUrl: './tireconnect-suppliers.component.html',
  styleUrls: ['./tireconnect-suppliers.component.scss'],
  providers: [DialogService],
})
export class TireConnectSuppliersComponent implements OnInit {
  connectedSuppliers: any[] = [];
  isLoading: boolean = false;

  constructor(private httpService: HTTPService, private dynamicDialogRef: DynamicDialogRef, private helperService: HelperService) {}

  ngOnInit(): void {
    this.getTireConnectConnectedSuppliers();
  }

  getTireConnectConnectedSuppliers() {
    this.isLoading = true;
    this.httpService
      .getTireConnectConnectedSuppliers()
      .then(
        (data: any) => {
          this.connectedSuppliers = data;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
      });
  }

  handleClose(isSuccess?: boolean) {
    this.dynamicDialogRef.close({ isSuccess });
  }
}
